<div style="width: 600px; height: 700px;" data-cy="letters-delivery-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="letters-delivery-header-section">
      <div class="section-header-title" data-cy="letters-delivery-title-text">
        Letters Delivery Options
      </div>
      <div style="flex: 1;"></div>
    </div>
    <div class="section-content" style="flex: 1;" data-cy="letters-delivery-content-section">
      <mat-form-field style="width: 100%;" data-cy="letters-delivery-email-from-field">
        <mat-label>Letters Email From:</mat-label>
        <mat-select [(value)]="selectedLocationId" data-cy="letters-delivery-email-from-select">
          @for (loc of locations; track loc.LOCID) {
            <mat-option [value]="loc.LOCID.toString()" [attr.data-cy]="'letters-delivery-email-from-option-' + loc.LOCID">
              {{ loc.Name }} — {{ loc.EmailReturnAddress }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 6px;" data-cy="letters-delivery-footer-section">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="letters-delivery-cancel-button">Cancel</button>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="letters-delivery-ok-button">Ok</button>
    </div>
  </div>
</div>
